import type { JSX } from "react"
import type { MenuSection as NullableMenuSection } from "./types/MenuSection"

type StrictMenuSection = JSX.Element[]

export const removeNull = (section: NullableMenuSection): StrictMenuSection => section.filter((item) => item !== null)
